export default __webpack_public_path__ + "static/media/testimonial-1.f05ca74e.svg";